import type { ICategory } from "@/types/models";
import { defineStore } from "pinia";
import { ref } from "vue";

export const useCategoryStore = defineStore("categoryStore", () => {
  // State
  const categories = ref<ICategory[]>([]);

  // Actions
  function setCategories(data: ICategory[]) {
    categories.value = data;
  }

  function clearCategories() {
    categories.value = [];
  }

  return {
    categories,
    setCategories,
    clearCategories
  };
});
